<template>
  <Flex grow justify-center pt-3 class="main-container">
    <Banner :alert="notification" @close="onBannerClose" />
    <BulkUpdateFeedback v-if="showFeedback" />
    <BulkUpdateInput v-if="!showFeedback" v-bind="$attrs" />
  </Flex>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { isEmpty } from 'lodash'
import Flex from '@wizer/core/components/flex/Flex.vue'
import Banner from '../components/Banner'
import BulkUpdateFeedback from '../components/bulkUpdate/BulkUpdateFeedback.vue'
import BulkUpdateInput from '../components/bulkUpdate/BulkUpdateInput.vue'

export default {
  name: 'BulkUpdate',

  components: {
    Flex,
    Banner,
    BulkUpdateFeedback,
    BulkUpdateInput,
  },

  computed: {
    ...mapState({
      feedbackObject: (state) => state.BulkUpdateFeedbackModule.feedbackObject,
      notifications: (state) => state.Notification.notifications,
    }),
    notification() {
      if (!this.notifications.length) return null
      return this.notifications.slice(-1)[0]
    },
    showFeedback() {
      return !isEmpty(this.feedbackObject)
    },
  },

  methods: {
    onBannerClose() {
      this.removeNotification(this.notifications.slice(-1)[0])
    },
    ...mapActions({ removeNotification: 'Notification/remove' }),
  },
}
</script>

<style lang="postcss">
.main-container {
  @apply .w-full;
}
</style>
